/* eslint-disable no-nested-ternary */
import { getDistance } from '@/utils/getDistance';

export function setNavigationDestination(locationTag: any, navigationSettings: any, setSliderValue: any) {
  const allTagsArray = Array.from(this.state.allTags, ([, value]: any) => value);

  if (!allTagsArray.length || !this.state.currentSweep) {
    return;
  }

  const target = allTagsArray
    // searching by temporary sid from Matterport
    .find((item: any) => item.sid === locationTag.sid || item.defaultSid === locationTag.sid);

  if (!target) {
    console.error('Target sweep not found');
    return;
  }

  const currentSID = this.state.currentSweep.sid || this.state.currentSweep.sweep || this.defaultSweep?.sid;
  const targetPosition = { x: target.positionX, y: target.positionY, z: target.positionZ };

  let closestSweep = this.state.sweeps.reduce(
    (closest, sweep) => {
      if (sweep.floor_index === target.floor) {
        const distance = getDistance(sweep.position, targetPosition);
        if (closest.distance === null || distance < closest.distance) {
          return { sweep, distance };
        }
      }
      return closest;
    },
    { sweep: null, distance: Infinity },
  ).sweep;
  if (!closestSweep) {
    console.warn('No sweep found on the same floor. Defaulting to closest sweep on any floor.');
    closestSweep = this.state.sweeps.reduce(
      (closest, sweep) => {
        const distance = getDistance(sweep.position, targetPosition);
        if (closest.distance === null || distance < closest.distance) {
          return { sweep, distance };
        }
        return closest;
      },
      { sweep: null, distance: Infinity },
    ).sweep;
  }
  const targetSID = closestSweep ? closestSweep.sid : null;

  if (!currentSID || !targetSID) {
    console.error('Current or Target sweep not found');
    return;
  }

  if (!currentSID) {
    console.error('Current sweep not found');
    return;
  }

  if (!this.pathFinderLine) {
    console.error('PathFinderLine not found');
    return;
  }

  this.setState({
    actionPathNavbarData: {
      enableNavBar: target.enableNavBar,
      destinationTitle: target.title,
      icon: target.iconFile
        ? `${process.env.REACT_APP_AWS}/tours/${target.tourId}/tags/icons/${target.iconFile}`
        : target.custom && target.customIcon !== 'null'
        ? target.iconColor
          ? `${process.env.REACT_APP_DOMAIN || 'http://localhost:5030'}/v1/public/icons/${target.customIcon}?hex=${encodeURIComponent(target.iconColor)}&circle=${
              target.whiteCircle
            }`
          : `${process.env.REACT_APP_DOMAIN || 'http://localhost:5030'}/v1/public/icons/${target.customIcon}`
        : null,
      autoNavigation: target.autoNavigation,
      enableTeleportBtn: target.enableTeleportBtn,
    },
    isNavigationBackgroundVisible: false,
    navigationTarget: target,
  });

  if (target.autoNavigation || navigationSettings?.autoMoveButtonEnabled) {
    if ((target.navigationAutoPlay || navigationSettings?.autoPlayEnabled) && this.pathFinderLine.targetObjectData?.id !== target.id) {
      if (this.currentSweep.id === '') {
        // start automatic navigation after sweep transition is finished
        const intervalID = setInterval(() => {
          if (this.currentSweep.id !== '') {
            this.setActionPathNavbarPlayButtonType('Pause');
            this.pathFinderLine.update(this.currentSweep.id, targetSID, target.title, target).then(() => {
              this.pathFinderLine
                .autoNavigateCurrentPath(
                  setSliderValue,
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  () => {},
                  () => {
                    this.pathFinderLine.inAutoNavigate = false;
                    this.setActionPathNavbarPlayButtonType('Play');
                  },
                  navigationSettings?.autoPlayEnabled,
                )
                .catch((e) => console.error(e));
            });
            clearInterval(intervalID);
          }
        }, 250);
      } else {
        this.pathFinderLine.update(currentSID, targetSID, target.title, target).then(() => {
          if (!this.pathFinderLine.hasTeleports) {
            this.setActionPathNavbarPlayButtonType('Pause');
            this.pathFinderLine
              .autoNavigateCurrentPath(
                setSliderValue,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                () => {},
                () => {
                  this.pathFinderLine.inAutoNavigate = false;
                  this.setActionPathNavbarPlayButtonType('Play');
                },
                navigationSettings?.autoPlayEnabled,
              )
              .catch((e) => console.error(e));
          }
        });
      }
    } else {
      this.setActionPathNavbarPlayButtonType('Play');
      this.pathFinderLine.update(currentSID, targetSID, target.title, target);
    }
    return;
  }

  if (this.pathFinderLine) {
    if (this.pathFinderLine.targetSID !== targetSID) this.pathFinderLine.update(currentSID, targetSID, target.title, target);
    else {
      this.pathFinderLine.reset();
    }
  }
}

export async function moveToStartingPoint() {
  const { navigationStartPosition } = this.state;
  if (navigationStartPosition) {
    const { s, x, y } = navigationStartPosition;
    await this.moveToSweep(s, { x, y }, 'INSTANT');
  }
  this.setState({ actionPathFinished: false, showActionPathBar: false });
  this.setActionPathNavbarPlayButtonType('Play');
  this.pathFinderLine.reset();
  return true;
}
